// @flow
import React from 'react';
import { compose } from 'redux';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { PaymentFormModal } from '@views';
import { paymentActions } from '@context/payments';
import { modalPatientId } from '@context/modals';
import { serviceTemplateActions } from '@context/serviceTemplates';
import type { Dispatch, PaymentCreateInput, ServicesState, Patient } from '@types';
import { withConfirmOnClose } from '@hocs';
import { isSecretary } from '@helpers/helpers';
import { mapPermissionTo } from '@helpers/connect';

type Props = {
  dispatch: Function,
  patientId: number,
  patient: Patient,
  doctorId: number,
  serviceTemplates: ServicesState,
  servicesByQuantity: boolean,
  setConfirmation: Function,
  closeModal: Function,
  doctorName: string,
  showDoctorName: boolean,
};

class PaymentNewFormModalContainer extends React.Component<Props> {
  componentDidMount() {
    const { dispatch, doctorId } = this.props;
    dispatch(serviceTemplateActions.getServiceTemplates(doctorId));
  }

  render() {
    const {
      serviceTemplates, patient, setConfirmation, doctorName, showDoctorName, servicesByQuantity,
    } = this.props;

    return (
      <PaymentFormModal
        title={showDoctorName ? `Novo Pagamento para ${doctorName}` : 'Novo Pagamento'}
        onSave={this.handleCreatePayment}
        onClose={this.closeModal}
        serviceTemplates={serviceTemplates}
        servicesByQuantity={servicesByQuantity}
        indebt={get(patient, 'indebt', false)}
        financialBalance={get(patient, 'financialBalance', false)}
        onSetConfirmOnClose={setConfirmation}
      />
    );
  }

  closeModal = this.props.closeModal;

  handleCreatePayment = (data: PaymentCreateInput) => {
    const { dispatch, patientId, doctorId } = this.props;

    dispatch(paymentActions.createPayment(patientId, {
      ...data,
      doctorId,
    }, (success) => {
      if (success) {
        // The id it saved to: the patient may not be in the store when the form outlived its page
        if ((data.payment.installments || 0) > 1) {
          dispatch(paymentActions.getPatientPayments(patientId));
        }
      }
    }));

    this.closeModal(true);
  };
}

const getDoctorId = (state) => (!isSecretary(state) && get(state, ['context', 'user', 'advancedData', 'doctorId'], null) ? get(state, ['context', 'user', 'advancedData', 'doctorId'], null) : get(state, ['context', 'modals', 'data', 'doctorId'], null));

const mapStateToProps = (state, ownProps) => {
  const patientId = modalPatientId(state, ownProps);
  return {
    serviceTemplates: get(state, ['context', 'serviceTemplates']),
    servicesByQuantity: !!mapPermissionTo(state).servicesByQuantity,
    patientId,
    patient: get(state, ['context', 'patients', 'data', String(patientId)]),
    doctorId: getDoctorId(state),
    doctorName: get(state, ['context', 'modals', 'data', 'doctorName'], null),
    showDoctorName: isSecretary(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({ dispatch });

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withConfirmOnClose(),
)(PaymentNewFormModalContainer);
